const CREATE_CHAIN_AND_CHANNEL =
  'bfb/StakeholderMap/combiners/DistributionChannels/CREATE_CHAIN_AND_CHANNEL';
const CREATE_CHAIN_AND_CHANNEL_FAILED =
  'bfb/StakeholderMap/combiners/DistributionChannels/CREATE_CHAIN_AND_CHANNEL_FAILED';

export default {
  CREATE_CHAIN_AND_CHANNEL,
  CREATE_CHAIN_AND_CHANNEL_FAILED,
};
